<template>
	<span v-if="color" class="inline-flex items-center gap-1 whitespace-nowrap">
		<span class="ral-swatch" :style="{ background: hex || 'transparent' }"></span>
		{{ color }}
	</span>
	<span v-else class="text-gray-400">-</span>
</template>

<script>
import ralColors from "@/assets/ral_colors.json";

export default {
	name: "RalSwatch",
	props: {
		color: { type: String, default: null },
	},
	computed: {
		hex() {
			if (!this.color) return null;
			const code = this.color.replace(/\D/g, "");
			const match = ralColors.find((c) => c.ral.replace(/\D/g, "") === code);
			return match ? match.hex : null;
		},
	},
};
</script>

<style scoped>
.ral-swatch {
	display: inline-block;
	width: 14px;
	height: 14px;
	border-radius: 3px;
	border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
